"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = __importDefault(require("../../../../../Utils"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/mms`;
    }
    /**
     * Creates and sends a new media message or multiple messages. Sending MMS
   * messages simultaneously to different recipients is limited up to 50
   * requests per minute; relevant for all client applications.
   *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/mms
     * Rate Limit Group: Medium
     * App Permission: SMS
     * User Permission: OutboundSMS
     */
    async post(createMMSMessage, restRequestConfig) {
        const formData = await Utils_1.default.getFormData(createMMSMessage);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map